// Chat widget placeholder - awaiting new chat script
export const openChat = () => {
  console.log('Chat widget not yet configured');
};
